{
  "name": "maas-admin-portal",
  "version": "1.5.0",
  "scripts": {
    "ng": "ng",
    "start": "node server.js",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "20.2.7",
    "@angular/localize": "20.3.3",
    "@angular/material": "20.2.7",
    "@angular/material-moment-adapter": "20.2.7",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "core-js": "2.5.4",
    "debug": "4.4.1",
    "file-saver": "2.0.5",
    "gentelella": "1.4.0",
    "iv-viewer": "^2.1.1",
    "keycloak-angular": "20.0.0",
    "keycloak-js": "^26.0.7",
    "lodash.clonedeep": "^4.5.0",
    "lodash.merge": "^4.6.2",
    "lodash.mergewith": "^4.6.2",
    "lodash.orderby": "^4.5.0",
    "moment": "^2.30.1",
    "ngx-extended-pdf-viewer": "25.5.1",
    "ngx-progressbar": "^11.1.0",
    "rison-node": "^2.1.1",
    "rxjs": "^7.4.0",
    "tippy.js": "^6.2.7",
    "tslib": "2.4.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.3",
    "@angular/animations": "20.3.3",
    "@angular/cli": "20.3.3",
    "@angular/common": "20.3.3",
    "@angular/compiler": "20.3.3",
    "@angular/compiler-cli": "20.3.3",
    "@angular/core": "20.3.3",
    "@angular/forms": "20.3.3",
    "@angular/language-service": "20.3.3",
    "@angular/platform-browser": "20.3.3",
    "@angular/platform-browser-dynamic": "20.3.3",
    "@angular/router": "20.3.3",
    "@types/jasmine": "~2.8.19",
    "@types/jasminewd2": "~2.0.10",
    "@types/node": "12.11.1",
    "jasmine-core": "~2.99.1",
    "jasmine-spec-reporter": "~4.2.1",
    "karma": "~6.3.20",
    "karma-chrome-launcher": "~2.2.0",
    "karma-coverage-istanbul-reporter": "~2.0.6",
    "karma-jasmine": "~1.1.2",
    "karma-jasmine-html-reporter": "0.2.2",
    "protractor": "^7.0.0",
    "sass": "1.50.1",
    "ts-node": "~7.0.1",
    "tslint": "~6.1.3",
    "typescript": "^5.8.3"
  }
}
